import { IFacialRecognitionProcess } from 'shared/domain/entities/facialRecognition';

interface IConstructor {
  budgetId: number;
  customerId: number;
}

export class AdditiveFacialRecognitionProcess
  implements IFacialRecognitionProcess
{
  public type: IFacialRecognitionProcess['type'] = 'ADDITIVE';
  public url: IFacialRecognitionProcess['url'];
  public key: IFacialRecognitionProcess['key'];
  public params: IFacialRecognitionProcess['params'];
  public trackingPayload: IFacialRecognitionProcess['trackingPayload'];

  constructor({ budgetId, customerId }: IConstructor) {
    this.url = `/caf/onboarding/${customerId}`;
    this.trackingPayload = {
      tipo: 'ADITIVO',
      idOrcamento: budgetId,
      idCliente: customerId,
    };
    this.key = [this.type, String(customerId), String(budgetId)];
    this.params = {
      idOrcamento: budgetId,
      tipoFluxo: 'ADITIVO',
    };
  }
}
